import ReactDOM from "react-dom"
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom"
import { Home, NoPage } from "./pages"

import './index.css'

export default function App() {  

    return (     
        <BrowserRouter>       
            <Routes>         
                <Route path="/" element={<Home />}>           
                <Route index element={<Home />} />           
                <Route path="privacy-policy" Component={() => {
                    window.location.replace('null');
                    return null;
                }}/>
                <Route path="*" element={<NoPage />} />
                </Route>      
            </Routes>     
        </BrowserRouter>   
    ) 
} ReactDOM.render(<App />, document.getElementById("root"))